/**
 * Certificado digital vencido (docs/PLANO_CERTIFICADO_EXPIRADO.md): o mesmo código
 * chega no `codigo` do 428 e no `codigoErro` do `carga.falhou`.
 */
export const CODIGO_CERT_EXPIRADO = 'CERTIFICADO_EXPIRADO';

/** Título do estado de erro de certificado: vencido ou ausente/recusado. */
export function tituloErroCertificado(codigo: string | null | undefined): string {
  return codigo === CODIGO_CERT_EXPIRADO ? 'Certificado digital vencido' : 'Certificado digital necessário';
}

/** Rótulo da ação que leva a Certificados. */
export function acaoErroCertificado(codigo: string | null | undefined): string {
  return codigo === CODIGO_CERT_EXPIRADO ? 'Enviar o renovado' : 'Configurar certificado';
}

/**
 * O certificado ativo do usuário já venceu (`certificate_valid_until` do `/auth/me`).
 * Na consulta ele vale como "sem certificado": os autos abrem pelo certificado
 * administrativo, só com os dados públicos (Res. 121), e peticionar fica bloqueado.
 */
export function certificadoVencido(validoAte: string | null | undefined, agora: number = Date.now()): boolean {
  if (!validoAte) return false;
  const fim = new Date(validoAte).getTime();
  return !Number.isNaN(fim) && fim <= agora;
}
